<template>
	<div class="stars-bar" role="img" :aria-label="`${clampedSelected}/${props.maxStars} stars`">
		<span v-for="n in clampedSelected" :key="`sel-${n}`" class="star selected" aria-hidden="true" />
		<span v-for="n in clampedUnselected" :key="`unsel-${n}`" class="star unselected" aria-hidden="true" />
	</div>
</template>

<script setup lang="ts">
	import { computed } from 'vue';

	const props = withDefaults(defineProps<{
		starsCount: number,
		maxStars?: number,
	}>(), {
		maxStars: 5,
	});

	const clampedSelected = computed(() => {
		const v = Number(props.starsCount) || 0;
		return Math.min(Math.max(v, 0), props.maxStars);
	});

	const clampedUnselected = computed(() => {
		return Math.max(props.maxStars - clampedSelected.value, 0);
	});
</script>

<style lang="scss" scoped>
.stars-bar {
		display: flex;
		gap: 3px;
		.star {
			display: block;
			width: 16px;
			height: 16px;
			background-repeat: no-repeat;
			background-position: center center;
			background-size: cover;
			&.selected {
				background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 14 14'%3E%3Cpath id='Polygon_5' data-name='Polygon 5' d='M7,0,9.1,4.7l4.9.648L10.4,8.9l.928,5.1L7,11.5,2.674,14,3.6,8.9,0,5.348,4.9,4.7Z' fill='%23FEDC4F'/%3E%3C/svg%3E%0A");
			}
			&.unselected {
				background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 14 14'%3E%3Cpath id='Polygon_5' data-name='Polygon 5' d='M7,0,9.1,4.7l4.9.648L10.4,8.9l.928,5.1L7,11.5,2.674,14,3.6,8.9,0,5.348,4.9,4.7Z' fill-opacity='0.25' fill='%23FFFFFF'/%3E%3C/svg%3E%0A");
			}
		}
	}
</style>
